module.exports = __webpack_public_path__ + "img/logo_v2.5c80f180.png";